import React, { useState, useEffect } from 'react';
import CheckAuth from '../../elements/checkAuth';
import axios from 'axios';
import config from '../../../../config/environment';
import Menu from '../../elements/Menu/menu';
import PageMode from '../../elements/PageMode/pageMode';
import './cashbackFee.css';

const MODES = [ 'ALL', 'BUY', 'SELL', 'EXCHANGE' ];

export default function CashbackFee() {
    const [state, setState] = useState({
        mode: 'ALL',
        analysisData: null,
        coinMarketCapBaseAmount: null,

        isHideDisabled: true
    });

    useEffect(() => {
        const main = async () => {
            const response = await axios.get(config.backendUrl + '/cashback/cashback-fee', { headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('jwtToken')
            } });
            console.log(response.data); // todo: remove this
            setState(state => { return {
                ...state,
                analysisData: response.data.analysisData,
                coinMarketCapBaseAmount: response.data.coinMarketCapBaseAmount
            } });
        };
        main();
    }, []);

    const modeOnChangeHandler = (event) => setState({ ...state, mode: event.target.value });

    const sortAllExchangeWays = (analysisData) => {
        let tmpArray = [ ...analysisData ];
        tmpArray = tmpArray.sort(getSortCallback('provider'));
    
        switch (state.mode) {
            case 'BUY':
                tmpArray = tmpArray.filter(value => value.exchangeWayType === 'BUY');
                tmpArray = tmpArray.sort(getSortCallback('inCurrencyCode'));
                tmpArray = tmpArray.sort(getSortCallback('inPaywayCode'));
                break;
            
            case 'SELL':
                tmpArray = tmpArray.filter(value => value.exchangeWayType === 'SELL');
                tmpArray = tmpArray.sort(getSortCallback('outCurrencyCode'));
                tmpArray = tmpArray.sort(getSortCallback('outPaywayCode'));
                break;

            case 'EXCHANGE':
                tmpArray = tmpArray.filter(value => value.exchangeWayType === 'EXCHANGE');
                tmpArray = tmpArray.sort(getSortCallback('inCurrencyCode'));
                tmpArray = tmpArray.sort(getSortCallback('inPaywayCode'));
                break;
        
            default:
                tmpArray = tmpArray.sort(getSortCallback('inCurrencyCode'));
                tmpArray = tmpArray.sort(getSortCallback('inPaywayCode'));
                tmpArray = tmpArray.sort(getSortCallback('exchangeWayType'));
                break;
        }

        tmpArray = state.isHideDisabled ? tmpArray.filter(value => value.isExchWayActive) : tmpArray;
    
        return tmpArray;
    };

    const getSortCallback = (param) => {
        switch (param) {
            case 'provider':
                return (a, b) => {
                    if (a.provider > b.provider) { return 1; }
                    if (a.provider < b.provider) { return -1; }
                    return 0;
                };
        
            case 'inCurrencyCode':
                return (a, b) => {
                    if (a.inCurrencyCode > b.inCurrencyCode) { return 1; }
                    if (a.inCurrencyCode < b.inCurrencyCode) { return -1; }
                    return 0;
                };
    
            case 'outCurrencyCode':
                return (a, b) => {
                    if (a.outCurrencyCode > b.outCurrencyCode) { return 1; }
                    if (a.outCurrencyCode < b.outCurrencyCode) { return -1; }
                    return 0;
                };
    
            case 'inPaywayCode':
                return (a, b) => {
                    if (a.inPaywayCode > b.inPaywayCode) { return 1; }
                    if (a.inPaywayCode < b.inPaywayCode) { return -1; }
                    return 0;
                };
    
            case 'outPaywayCode':
                return (a, b) => {
                    if (a.outPaywayCode > b.outPaywayCode) { return 1; }
                    if (a.outPaywayCode < b.outPaywayCode) { return -1; }
                    return 0;
                };

            case 'exchangeWayType':
                return (a, b) => {
                    if (a.exchangeWayType > b.exchangeWayType) { return 1; }
                    if (a.exchangeWayType < b.exchangeWayType) { return -1; }
                    return 0;
                };

            default: return null;
        }
    };

    const hideDisabledChangeHandler = () => setState({ ...state, isHideDisabled: !state.isHideDisabled });

    const renderTable = () => {
        if (!state.analysisData) { return; }

        const renderArray = sortAllExchangeWays(state.analysisData);

        return(
            <div className="cashbackFee__table_wrapper">
                <table className="table">
                    <thead>
                        <tr>
                            <th>
                                Exchange way ID
                                <div>
                                    <input type="checkbox" checked={ state.isHideDisabled } onChange={ hideDisabledChangeHandler }/>
                                    <span>hide disabled</span>
                                </div>
                            </th>
                            <th>Exchange way type</th>
                            <th>Provider</th>
                            <th>In currency code</th>
                            <th>Out currency code</th>
                            <th>In payway code</th>
                            <th>Out payway code</th>
                            <th>Percent difference</th>
                            <th>CoinMarket equivalent [500$]</th>
                            <th>Trustee equivalent [500$]</th>
                            <th>BestChange equivalent [500$]</th>
                            <th>BestChange best rate</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            renderArray.map((data, index) => {
                                return(
                                    <tr key={ index }>
                                        <td>{ data.exchangeWayId + ' ' + (data.isExchWayActive ? '[enabled]' : '[disabled]') }</td>
                                        <td>{ data.exchangeWayType }</td>
                                        <td>{ data.provider }</td>
                                        <td>{ data.inCurrencyCode }</td>
                                        <td>{ data.outCurrencyCode }</td>
                                        <td>{ data.inPaywayCode }</td>
                                        <td>{ data.outPaywayCode }</td>
                                        <td className={ data.isProfit ? 'cashbackFee__color_green' : 'cashbackFee__color_red' }>{ (data.isProfit ? '+' : '-') + data.percentDifference + '%' }</td>
                                        <td>{ data.coinMarketEquivalent + ' ' + (data.exchangeWayType === 'SELL' ? data.inCurrencyCode : data.outCurrencyCode) }</td>
                                        <td>{ data.trusteeEquivalent + ' ' + (data.exchangeWayType === 'SELL' ? data.outCurrencyCode : data.inCurrencyCode) }</td>
                                        <td>{ data.bestChangeEquivalent + ' ' + (data.exchangeWayType === 'SELL' ? data.outCurrencyCode : data.inCurrencyCode) }</td>
                                        <td>{ data.bestChangeBestRate + ' ' + (data.exchangeWayType === 'SELL' ? data.outCurrencyCode : data.inCurrencyCode) }</td>
                                    </tr>
                                );
                            })
                        }
                    </tbody>
                </table>
            </div>
        );
    };

    return(
        <>
        <CheckAuth />
        <Menu />
        <div className="">
            <PageMode modesArray={ MODES } checkedMode={ state.mode } onChangeHandler={ modeOnChangeHandler } />
            { renderTable() }
        </div>
    </>
    );
};